import { canUseDOM } from '@ps/web-core-utils';
import { useEffect, useState } from 'react';

export const useDelayedSwitch = (startDelay: boolean, delay = 500): boolean => {
  const [state, setState] = useState(false);

  useEffect(() => {
    if (canUseDOM && startDelay) {
      setState(true);
    }
  }, [delay, startDelay]);

  useEffect(() => {
    let timeout: number;

    if (state) {
      timeout = window.setTimeout(() => setState(false), delay);
    }

    return () => {
      timeout && clearTimeout(timeout);
    };
  }, [delay, state]);

  return state;
};
